import { render } from "./identifiant.vue?vue&type=template&id=02e86e03&scoped=true"
import script from "./identifiant.vue?vue&type=script&lang=js"
export * from "./identifiant.vue?vue&type=script&lang=js"

import "./identifiant.vue?vue&type=style&index=0&id=02e86e03&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e86e03"]])

export default __exports__